export const removeSpaces = (string) => {
  let trimmedString = string.replaceAll(" ", "");
  return trimmedString;
};

export const stringToUpper = (string) => {
  return string.toUpperCase();
};
